import { useQuery } from "@tanstack/react-query";
import { apiCall } from "../lib/apiClient";
import type { MyCardsResponse } from "../schemas/myCards";

/**
 * Holder „Moje karty" query — `/api/tenant/my-cards`.
 *
 * Vrací tankovací karty navázané na přihlášeného uživatele (přes holder.user_id),
 * číslo karty maskované (last-6). RLS izolace = backend (princip #6).
 */
const KEY_MY_CARDS = ["tenant", "my-cards"] as const;

export function useMyCards() {
  return useQuery({
    queryKey: KEY_MY_CARDS,
    queryFn: () => apiCall<MyCardsResponse>("/api/tenant/my-cards"),
    staleTime: 60_000,
  });
}

export const MY_CARDS_QUERY_KEY = KEY_MY_CARDS;
